import { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { getFromStorage, setToStorage } from '../helpers/filter';
const FilterContext = createContext({});

export function FilterProvider({ children }) {
    const { enterpriseId } = useSelector((state) => state.auth);

    const getFiltersForPage = (pageId) => {
        return getFromStorage(enterpriseId, pageId);
    };

    const setFiltersForPage = (pageId, value) => {
        setToStorage(enterpriseId, pageId, value);
    };

    return (
        <FilterContext.Provider
            value={{
                getFiltersForPage,
                setFiltersForPage
            }}>
            {children}
        </FilterContext.Provider>
    );
}

export function usePersistedFiltering() {
    return useContext(FilterContext);
}
